import React from 'react';
import Head from 'next/head';
import { getCookie } from 'cookies-next';
import { Button } from '@components/atoms/Button/Button';
import { Genre } from '@components/atoms/Genre/Genre';
import { LoadingIndicator } from '@components/atoms/LoadingIndicator/LoadingIndicator';
import { Oewa } from '@components/atoms/Oewa/Oewa';
import { Title } from '@components/atoms/Title';
import { GetGenresDocument } from '@lib/graphql/generated';
import { createUrqlClient, usePaginatedQuery } from '@lib/graphql/urql';
import { useTagManager } from '@lib/hooks/useTagManager';

export function GenreIndex() {
  const [{ data: genresData, fetching, stale, hasMorePages, fetchNextPage }] = usePaginatedQuery({
    query: GetGenresDocument,
    variables: { first: 200, page: 1 },
  });
  const genres = genresData?.flatMap((data) => data?.genres?.data);

  useTagManager({
    event: 'metadata',
    loginStatus: 'nicht eingeloggt',
    seitentyp: 'Genres',
    titel: 'Genres',
    oewaSeitenkontingent: 'Service',
    oewaSubkontingent: 'Programmeundlokalfuehrer',
    oewaProfilingkontingent: 'TVProgramme',
    cookieAlert: getCookie('OptanonConsent'),
  });

  return (
    <div>
      <Oewa pageKey={'Service'} categoryKey={'Programmeundlokalfuehrer'} profileKey={'TVProgramme'} />
      <Head>
        <title>TV-Media</title>
      </Head>
      <Title classProps={{ heading: 'text-base lg:text-xl mb-6 leading-11 lg:leading-12' }} level={1}>
        Genres
      </Title>
      <div className="grid grid-cols-fill-streaming-squares gap-4">
        {genres?.map((genre) => <Genre key={genre.id} genre={genre} type="medium" />)}
      </div>
      <LoadingIndicator visible={fetching && genres?.length < 1} />
      <div>
        {hasMorePages && (
          <div className="text-center">
            <Button
              hasAction
              title="Mehr anzeigen"
              isLoading={fetching || stale}
              onAction={() => setTimeout(fetchNextPage)}
              buttonStyle="secondary"
              classProps={{ root: 'mt-6' }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export async function genresSsrLogic() {
  const { ssrQuery, ssrCache } = createUrqlClient();
  await ssrQuery({
    query: GetGenresDocument,
    variables: { first: 200, page: 1 },
  });

  return {
    props: {
      slug: 'index',
      urqlState: ssrCache.extractData(),
    },
  };
}
